import z from 'zod'
import { nullSafeFirestoreTimestamp } from '../shared/schema'

export const schema = z.object({
  institutionName: z.string(),
  ltiPayloadIssues: z
    .record(
      z.string(),
      z.object({
        type: z.string(),
        deploymentId: z.string(),
        problems: z.array(z.string()),
      })
    )
    .optional(),
  updatedAt: nullSafeFirestoreTimestamp(),
})

export const writeSchema = schema.extend({})

export const empty = Object.freeze(
  schema.parse({
    institutionName: '',
  })
)

export type FirestoreInstitution = z.infer<typeof schema>
